import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule, IScheduleTemplate, TemplateName } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { applyChanges, scheduleTemplates } from './WizardCalc';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IHandoverSetting } from '../ScheduleCalc';
import { calculateHandoverDays } from '../ChangeTimePlace/ChangeTimePlaceCalc';
import ChangeTimePlaceDay from '../ChangeTimePlaceDay';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditActionStyle> {
  family:IFamilyMember[];
  offset:number;

  aPickup:IHandoverSetting[];
  bPickup:IHandoverSetting[];

  scheduleEditPreview:ISchedule|undefined;
  selectedDays:IDateRange[];

  setHandover:(side:"parentA"|"parentB", index:number, settings:IHandoverSetting, direct:boolean) => void;
}

interface IState {
  aPickupDays:number[];
  bPickupDays:number[];
}

class WizardHandover extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    
    let aPickupDays = [0,0,0,0,0,0,0];
    let bPickupDays = [0,0,0,0,0,0,0];

    if (props.scheduleEditPreview) {
      const handovers = calculateHandoverDays(props.selectedDays, props.scheduleEditPreview);
      aPickupDays =handovers.parentApickupDays;
      bPickupDays=handovers.parentBpickupDays;
    }

    this.state = {    
      aPickupDays,
      bPickupDays,
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.scheduleEditPreview !== undefined && (
      prevProps.selectedDays !== this.props.selectedDays 
      ||  prevProps.scheduleEditPreview !== this.props.scheduleEditPreview)) {
      const handovers = calculateHandoverDays(this.props.selectedDays, this.props.scheduleEditPreview);
      this.setState({aPickupDays:handovers.parentApickupDays, bPickupDays:handovers.parentBpickupDays});
    }
  }

  public render() {
    const {classes, aPickup, bPickup, offset, family} = this.props;

    const pADays:JSX.Element[] = [];
    const pBDays:JSX.Element[] = [];

    let pA:number|undefined;
    let pB:number|undefined;

    if (this.props.scheduleEditPreview) {
      pA = this.props.scheduleEditPreview.data.parentA;
      pB = this.props.scheduleEditPreview.data.parentB;
    }

    const school = this.props.scheduleEditPreview?this.props.scheduleEditPreview.school:undefined;
    const schoolAge = schoolAgeFromFamily(family);

    let totalChanges = 0;
    for (let index = 0; index < this.state.aPickupDays.length; index++) {
      const occurences = this.state.aPickupDays[index];
      totalChanges += occurences;
      if (occurences > 0) {
        pADays.push(<ChangeTimePlaceDay
          key={"parentA"+index}
          title={tn.lang.getWeekdayName(index)}
          occurences={occurences}
          atSchool={aPickup[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={aPickup[index].location}
          hour={aPickup[index].hour}
          minute={aPickup[index].minute}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.props.setHandover("parentA", index, {atSchool,location:loc,hour,minute},direct)}
        />)
      }
    }

    for (let index = 0; index < this.state.bPickupDays.length; index++) {
      const occurences = this.state.bPickupDays[index];
      totalChanges += occurences;
      if (occurences > 0) {
        pBDays.push(<ChangeTimePlaceDay
          key={"parentB"+index}
          title={tn.lang.getWeekdayName(index)}
          occurences={occurences}
          atSchool={bPickup[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={bPickup[index].location}
          hour={bPickup[index].hour}
          minute={bPickup[index].minute}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.props.setHandover("parentB", index, {atSchool,location:loc,hour,minute},direct)}
        />)
      }
    }

    return (
      <div className={classes.pane+" "+classes.paneStep} style={{ left: (offset*100)+"%", opacity:offset===0?1:0, 
        gap: '16px', paddingTop: '16px'}}>
        <div className={classes.pane}>
          <div className={classes.handoverDayDetails} style={pADays.length>0?{}:{display:'none'}}>
            <span style={{fontSize:'11px'}}>{tn.lang.calWhenExchange}</span>
            <span className={classes.handoverGroupTitle}>
              {tn.lang.calHandoverToFrom(tn.familyMemberName(pB,family), tn.familyMemberName(pA,family))}
            </span>
          </div>
          {pADays}
          <div className={classes.handoverDayDetails} style={pBDays.length>0?{}:{display:'none'}}>
            <span style={{fontSize:'11px',marginTop: '20px'}}>{tn.lang.calWhenExchange}</span>
            <span className={classes.handoverGroupTitle}>
              {tn.lang.calHandoverToFrom(tn.familyMemberName(pA,family), tn.familyMemberName(pB,family))}
            </span>
          </div>
          {pBDays}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {

  return {
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditActionStyle)(WizardHandover));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardHandover.tsx